import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Loader2, AlertTriangle } from 'lucide-react';

// API-tól várt letöltés struktúra
interface ApiDownload {
    id: number;
    name: string;
    slug: string;
    created_at: string;
}

const fetchRecentDownloads = async (): Promise<ApiDownload[]> => {
    try {
        const res = await fetch(`/api/downloads/recent`);
        if (!res.ok) throw new Error('A letöltések lekérdezése sikertelen.');
        const apiData: ApiDownload[] = await res.json();

        return apiData;

    } catch (err) {
        console.error(err);
        throw err;
    }
};

const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toLocaleString('hu-HU', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    });
};

const RecentDownloadsPanel: React.FC = () => {
    const navigate = useNavigate();
    const { data: downloads, isLoading, isError } = useQuery({
        queryKey: ['recentDownloadsPanel'],
        queryFn: fetchRecentDownloads,
    });

    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-full min-h-40 bg-card rounded-lg">
                <Loader2 className="w-8 h-8 animate-spin text-primary" />
            </div>
        );
    }

    if (isError) {
        return (
            <div className="flex items-center justify-center h-full min-h-40 bg-card rounded-lg text-destructive">
                <AlertTriangle className="w-8 h-8 mr-2" /> Hiba
            </div>
        );
    }

    return (
        <div className="w-full max-h-40 flex flex-col overflow-hidden">
            <div className="flex-1 overflow-y-auto">
                {(downloads || []).length === 0 ? (
                    <p className="text-muted-foreground text-center py-8">Nincsenek letöltések</p>
                ) : (
                    <div className="space-y-2">
                        {(downloads || []).map((download) => (
                            <div
                                key={download.id}
                                onClick={() => navigate(`/games/${download.slug}`)}
                                className="p-3 rounded-lg bg-secondary hover:bg-muted transition-colors cursor-pointer"
                            >
                                <p className="font-semibold text-foreground line-clamp-1">
                                    {download.name}
                                </p>
                                <p className="text-xs text-muted-foreground">
                                    {formatDate(download.created_at)}
                                </p>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default RecentDownloadsPanel;
